/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { EntityComponentSetComponentsForPatch } from '../../../../../../Services/component';
import { FormComponents } from './CreateComponentsArray.defs';

/**
 * Create components array.
 * @param {FormComponents} components Form components props.
 * @export
 * @returns {Record<string, Array<EntityComponentSetComponentsForPatch>>} Components array.
 */
export const createComponentsArray = (
  components: FormComponents,
): Record<string, Array<EntityComponentSetComponentsForPatch>> => {
  let componentsArray: Record<string, Array<EntityComponentSetComponentsForPatch>> = {};

  Object.keys(components).forEach((component: string) => {
    const componentVersions = components[component];

    const newComponent = componentVersions.map((componentVersion) => ({
      environmentVariables: componentVersion.environmentVariables,
      version: componentVersion.version,
    }));

    componentsArray = {
      ...componentsArray,
      [component]: newComponent,
    };
  });

  return componentsArray;
};
